import styled from 'styled-components';

import { Horizontal } from '@sorare/core/src/atoms/layout/flex';
import { laptopAndAbove } from '@sorare/core/src/style/mediaQuery';

import { firstCellPadding, lastCellPadding } from '../BenchObjectTable/ui';

const Cell = styled(Horizontal)`
  white-space: nowrap;
  background-color: var(--c-nd-50-opaque);
  padding-top: var(--half-unit);
  padding-bottom: var(--half-unit);
  height: 100%;
  min-height: 28px;
`;

export const FirstCell = styled(Cell)`
  ${firstCellPadding}
`;
export const LastCell = styled(Cell)`
  ${lastCellPadding}
  justify-content: flex-end;
`;

export const MatchupsCell = styled(Cell)`
  justify-content: center;
  padding-inline: var(--unit);
`;

export const StatsCell = styled(Cell)`
  justify-content: center;
  width: 100%;
  padding-inline: var(--unit);
  @media ${laptopAndAbove} {
    padding-inline: var(--intermediate-unit);
  }
`;
